<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
    >
      <el-form-item label="签到规则名称" prop="signedName">
        <el-input
          maxlength="25"
          :disabled="ruleForm.enabledState == 'true' ? true : false"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.signedName"
          placeholder="请输入签到规则名称（20文本内）"
        ></el-input>
      </el-form-item>

      <el-form-item label="签到规则类型" prop="signedType">
        <el-select
          disabled
          size="small"
          style="width: 170px;"
          clearable
          v-model.trim="ruleForm.signedType"
          placeholder="请选择规则类型"
        >
          <el-option label="每日签到" value="1"></el-option>
          <el-option label="连续签到" value="3"></el-option>
          <el-option label="节假日签到" value="4"></el-option>
          <el-option label="累计签到" value="2"></el-option>
        </el-select>
        <div class="form-tip">
          不同活动类型签到，可以同时生效；同一种活动不允许同时设置多条规则
        </div>
      </el-form-item>

      <el-form-item label="签到规则优先级" prop="signedPriority">
        <el-select
          :disabled="ruleForm.enabledState == 'true' ? true : false"
          size="small"
          style="width: 170px;"
          clearable
          v-model.trim="ruleForm.signedPriority"
          placeholder="请选择签到优先级"
        >
          <el-option label="低" value="3"></el-option>
          <el-option label="中" value="2"></el-option>
          <el-option label="高" value="1"></el-option>
        </el-select>
        <div class="form-tip">
          级别越高，同类型活动级别高的优先生效显示在手机端
        </div>
      </el-form-item>

      <el-form-item label="签到活动日期：" prop="applyDate">
        <el-date-picker
          :disabled="true"
          v-model.trim="ruleForm.applyDate"
          type="datetimerange"
          align="right"
          :picker-options="pickerOptions"
          start-placeholder="活动开始时间"
          end-placeholder="活动结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <div class="form-tip">
          为避免对历史活动参与人员带来数据影响，活动时间设置必须大于当前时间
        </div>
      </el-form-item>

      <el-form-item v-if="ruleForm.signedType == 2 || ruleForm.signedType == 3" label="是否开启周期限制：" prop="cycleLimitState">
        <el-switch
            v-model="ruleForm.cycleLimitState"
            active-text="开启"
            inactive-text="关闭"
            :disabled="true"
            active-value="yes"
            inactive-value="no"
        >
        </el-switch>
        <div class="form-tip" style="color: #F72B2B">(即在活动时间范围内,每个周期时间到了,之前的签到次数清零,下一周期重新计算签到次数)</div>
        <div class="flex item-center" v-if="ruleForm.cycleLimitState == 'yes'">
          <el-radio-group v-model="ruleForm.cycleType" :disabled="true">
            <el-radio :label="'month'">自然月周期</el-radio>
            <el-radio :label="'custom'">自定义循环周期</el-radio>
          </el-radio-group>
          <div class="ml20" style="font-size: 13px"  v-if="ruleForm.cycleType == 'custom'">
            固定周期
            <el-input
                size="small"
                clearable
                :disabled="true"
                style="width: 80px; margin: 0 5px;"
                v-model.trim="ruleForm.customCycleNum"
            ></el-input>
            天<span class="form-tip" v-if="!isArray(ruleForm.applyDate) || ruleForm.applyDate.length < 1 ">(请先选择活动日期)</span>
          </div>
        </div>
        <div class="form-tip" v-if="ruleForm.cycleLimitState == 'yes' && ruleForm.cycleType == 'month'">即系统每月1号0点自动清空上月签到总次数,重新进入新的一个计算周期</div>
        <div class="form-tip flex item-center" v-if="ruleForm.cycleLimitState == 'yes' && ruleForm.cycleType == 'custom' && isArray(ruleForm.applyDate) && ruleForm.applyDate.length > 0 && ruleForm.customCycleNum">
          <div>
            当前周期:
            <span style="margin-left: 5px">{{ moment(ruleForm.applyDate[0]).format('YYYY-MM-DD') }}至{{ moment(ruleForm.applyDate[0]).add(Number(ruleForm.customCycleNum) -1,'days').format('YYYY-MM-DD') }}</span>
          </div>
          <div class="ml20">
            下一周期:
            <span style="margin-left: 5px">{{ moment(ruleForm.applyDate[0]).add(ruleForm.customCycleNum,'days').format('YYYY-MM-DD') }}至{{ moment(ruleForm.applyDate[0]).add(Number(ruleForm.customCycleNum)  + Number(ruleForm.customCycleNum) -1 ,'days').format('YYYY-MM-DD') }}</span>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="奖励规则" prop="integralAmount">
        <div class="table">
          <div class="table-header flex">
            <div class="flex-1 text-center">奖品规则编号</div>
            <!-- <div class="flex-1 text-center">赠送积分</div> -->
            <div
              class="flex-1 text-center"
              v-if="ruleForm.signedType == 2 || ruleForm.signedType == 3"
            >
              {{ ruleForm.signedType == 3 ? "连续签到第" : "累计签到" }}
            </div>

            <div class="flex-1 text-center">
              请选择奖品类型
            </div>
            <el-tooltip
              class="item"
              effect="dark"
              content="优惠券发放请先设置发放规则为“活动发放”的优惠券包，且每个活动券包只能在一个活动中使用，不可复用"
              placement="top"
            >
              <div class="flex-1 text-center primary">
                请选择奖品
              </div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="单人获得此项奖励上限，超出限制将不会获得奖励"
              placement="top"
            >
              <div class="flex-1 text-center primary">单人奖励次数上限</div>
            </el-tooltip>
            <div
              class="flex-1 text-center"
              v-show="ruleForm.enabledState == 'true' ? false : true"
              v-if="ruleForm.signedType == 2 || ruleForm.signedType == 3"
            >
              操作
            </div>
          </div>
          <div class="table-body">
            <div
              class="flex table-row item-center"
              v-for="(item, index) in ruleForm.signedRuleJson"
              :key="index"
            >
              <div class="flex-1 text-center">
                {{ index + 1 }}
              </div>

              <!-- 赠送积分 -->
              <!-- <div class="flex-1 text-center">
                <el-input
                  :disabled="ruleForm.enabledState == 'true' ? true : false"
                  v-model="item.integralAmount"
                  type="number"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  @mousewheel.prevent.native
                  style="width: 100px;"
                  size="mini"
                ></el-input>
              </div> -->

              <!-- 连续签到 -->
              <div class="flex-1 text-center" v-if="ruleForm.signedType == 3">
                <el-input
                  :disabled="ruleForm.enabledState == 'true' ? true : false"
                  type="number"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  @mousewheel.prevent.native
                  v-model="item.continuityDay"
                  style="width: 100px;"
                  size="mini"
                ></el-input
                ><span>天</span>
              </div>

              <!-- 累计签到 -->
              <div class="flex-1 text-center" v-if="ruleForm.signedType == 2">
                <el-input
                  :disabled="ruleForm.enabledState == 'true' ? true : false"
                  type="number"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  @mousewheel.prevent.native
                  v-model="item.addupDay"
                  style="width: 100px;"
                  size="mini"
                ></el-input
                ><span>天</span>
              </div>
              <div class="flex-1 text-center">
                <el-select
                  clearable
                  size="small"
                  v-model="item.rewardType"
                  placeholder="请选择奖品类型"
                  @change="prizeTypeChange(index)"
                >
                  <el-option label="积分" value="1"></el-option>
                  <el-option label="优惠劵" value="2"></el-option>
                  <!-- <el-option label="积分+优惠劵" value="2"></el-option> -->
                </el-select>
              </div>
              <!-- 赠送优惠券包 -->
              <div class="flex-1 text-center">
                <el-input
                  type="number"
                  @mousewheel.prevent.native
                  v-if="item.rewardType == '1'"
                  style="width: 140px"
                  v-model.trim="item.integralAmount"
                  @input="filterGt0OrFixed0('integralAmount', index)"
                  size="small"
                  clearable
                  placeholder="奖品积分"
                ></el-input>
                <!-- <span v-if="item.rewardType == '2'">+</span> -->
                <el-select
                  v-if="item.rewardType == '2'"
                  filterable
                  size="small"
                  style="width: 170px;"
                  clearable
                  v-model="item.couponsId"
                  placeholder="请选择赠送优惠包"
                  @change="couponsIdChange(index)"
                >
                  <el-option
                    :label="item.name"
                    :value="item.couponSendId"
                    v-for="(item, i) in findCouponSendByEvent"
                    :key="i"
                  ></el-option>
                </el-select>
              </div>

              <!-- 单人奖励次数上限 -->
              <div class="flex-1 text-center">
                <el-input
                  :disabled="ruleForm.enabledState == 'true' ? true : false"
                  type="number"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  @mousewheel.prevent.native
                  v-model="item.rewardUpperLimit"
                  style="width: 100px;"
                  size="mini"
                ></el-input>
              </div>

              <!-- 操作 -->
              <div
                class="flex-1"
                v-if="ruleForm.signedType == 2 || ruleForm.signedType == 3"
                v-show="ruleForm.enabledState == 'true' ? false : true"
              >
                <div class="add-wrapper flex flex-center" v-if="index === 0">
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addChild(index)"
                  ></span>
                </div>
                <div class="minus-wrapper flex flex-center" v-else>
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteChild(item, index)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="签到详情描述" prop="signedRemark">
        <el-input
          :disabled="ruleForm.enabledState == 'true' ? true : false"
          style="width:500px"
          type="textarea"
          v-model="ruleForm.signedRemark"
          placeholder="多行文本，显示在手机端先到详情说明，限制200个文本 内，非必填，无内容则手机端显示内容为空"
        ></el-input>
      </el-form-item>

      <el-form-item label="是否开启" prop="enabledState">
        <el-switch
          active-value="true"
          inactive-value="false"
          v-model="ruleForm.enabledState"
        ></el-switch>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;
      let upperLimit = false;
      if (!this.ruleForm.signedType) {
        haveEmptyCondition = true;
      }
      if (
        this.ruleForm.signedType === "1" ||
        this.ruleForm.signedType === "4"
      ) {
        this.ruleForm.signedRuleJson.map(v => {
          if (v.rewardType == "1") {
            for (let key in v) {
              if (
                // key === "integralAmount" ||
                // key === "couponsId" ||
                key === "rewardUpperLimit" ||
                key === "integralAmount"
              ) {
                if (v.rewardUpperLimit !== "0") {
                  if (!v[key]) {
                    haveEmptyCondition = true;
                  }
                } else {
                  upperLimit = true;
                }
              }
            }
          } else if (v.rewardType == "2") {
            for (let key in v) {
              if (
                // key === "integralAmount" ||
                key === "couponsId" ||
                key === "rewardUpperLimit"
                // key === "integralAmount"
              ) {
                if (v.rewardUpperLimit !== "0") {
                  if (!v[key]) {
                    haveEmptyCondition = true;
                  }
                } else {
                  upperLimit = true;
                }
              }
            }
          }
          // else if (v.rewardType == "2") {
          //   for (let key in v) {
          //     if (
          //       // key === "integralAmount" ||
          //       key === "couponsId" ||
          //       key === "rewardUpperLimit" ||
          //       key === "integralAmount"
          //     ) {
          //       if (v.rewardUpperLimit !== "0") {
          //         if (!v[key]) {
          //           haveEmptyCondition = true;
          //         }
          //       } else {
          //         upperLimit = true;
          //       }
          //     }
          //   }
          // }
        });
      }
      if (this.ruleForm.signedType === "3") {
        this.ruleForm.signedRuleJson.map(v => {
          if (v.rewardType == "1") {
            for (let key in v) {
              if (
                // key === "integralAmount" ||
                // key === "couponsId" ||
                key === "rewardUpperLimit" ||
                key === "continuityDay" ||
                key === "integralAmount"
              ) {
                if (v.rewardUpperLimit !== "0") {
                  if (!v[key]) {
                    haveEmptyCondition = true;
                  }
                } else {
                  upperLimit = true;
                }
              }
            }
          } else if (v.rewardType == "2") {
            for (let key in v) {
              if (
                // key === "integralAmount" ||
                key === "couponsId" ||
                key === "rewardUpperLimit" ||
                key === "continuityDay"
                // key === "integralAmount"
              ) {
                if (v.rewardUpperLimit !== "0") {
                  if (!v[key]) {
                    haveEmptyCondition = true;
                  }
                } else {
                  upperLimit = true;
                }
              }
            }
          }
          // else if (v.rewardType == "2") {
          //   for (let key in v) {
          //     if (
          //       // key === "integralAmount" ||
          //       key === "couponsId" ||
          //       key === "rewardUpperLimit" ||
          //       key === "continuityDay" ||
          //       key === "integralAmount"
          //     ) {
          //       if (v.rewardUpperLimit !== "0") {
          //         if (!v[key]) {
          //           haveEmptyCondition = true;
          //         }
          //       } else {
          //         upperLimit = true;
          //       }
          //     }
          //   }
          // }
        });
      }
      if (this.ruleForm.signedType === "2") {
        this.ruleForm.signedRuleJson.map(v => {
          if (v.rewardType == "1") {
            for (let key in v) {
              if (
                // key === "integralAmount" ||
                // key === "couponsId" ||
                key === "rewardUpperLimit" ||
                key === "addupDay" ||
                key === "integralAmount"
              ) {
                if (v.rewardUpperLimit !== "0") {
                  if (!v[key]) {
                    haveEmptyCondition = true;
                  }
                } else {
                  upperLimit = true;
                }
              }
            }
          } else if (v.rewardType == "2") {
            for (let key in v) {
              if (
                // key === "integralAmount" ||
                key === "couponsId" ||
                key === "rewardUpperLimit" ||
                key === "addupDay"
                // key === "integralAmount"
              ) {
                if (v.rewardUpperLimit !== "0") {
                  if (!v[key]) {
                    haveEmptyCondition = true;
                  }
                } else {
                  upperLimit = true;
                }
              }
            }
          }
          // else if (v.rewardType == "2") {
          //   for (let key in v) {
          //     if (
          //       // key === "integralAmount" ||
          //       key === "couponsId" ||
          //       key === "rewardUpperLimit" ||
          //       key === "addupDay" ||
          //       key === "integralAmount"
          //     ) {
          //       if (v.rewardUpperLimit !== "0") {
          //         if (!v[key]) {
          //           haveEmptyCondition = true;
          //         }
          //       } else {
          //         upperLimit = true;
          //       }
          //     }
          //   }
          // }
        });
      }
      if (haveEmptyCondition) {
        return callback(new Error("请填写完所有项"));
      }
      if (upperLimit) {
        return callback(new Error("单人奖励次数上限不能为0"));
      }
      callback();
    }.bind(this);

    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      ruleForm: {
        signedName: "",
        signedType: "",
        signedPriority: "",
        applyDate: [],
        enabledState: false,
        signedRemark: "",
        signedRuleJson: [
          {
            rewardType: "",
            integralAmount: "",
            couponsId: "",
            rewardUpperLimit: "",
            addupDay: "",
            continuityDay: ""
          }
        ],
        cycleType: "month",
        customCycleNum: "",
        cycleLimitState: "no"
      },
      rules: {
        signedName: [
          { required: true, message: "请输入签到规则名称", trigger: "blur" },
          { max: 20, message: "长度在20个字符内", trigger: "blur" }
        ],
        signedType: [
          { required: true, message: "请选择签到规则类型", trigger: "blur" }
        ],
        signedPriority: [
          { required: true, message: "请选择签到优先级", trigger: "blur" }
        ],
        applyDate: [
          { required: true, message: "请选择签到活动日期", trigger: "blur" }
        ],
        integralAmount: [
          { required: true, validator: patternLocation, trigger: "blur" }
        ],
        signedRemark: [
          { required: false, message: "请输入详情描述", trigger: "blur" },
          { max: 200, message: "长度在200个字符内", trigger: "blur" }
        ]
      }
    };
  },
  computed: mapGetters(["editActivity", "findCouponSendByEvent"]),
  watch: {
    "ruleForm.signedType": {
      handler(val) {
        if (val == 1 || val == 4) {
          this.ruleForm.signedRuleJson = this.ruleForm.signedRuleJson.splice(
            0,
            1
          );
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.detailSignInActivity().then(res => {
      const result = res.result || {};
      if (res.code == 0) {
        for (let key in result.signedActivityInfo) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = result.signedActivityInfo[key];
          }
        }
        this.ruleForm.applyDate = [
          result.signedActivityInfo.signedStartday,
          result.signedActivityInfo.signedEndday
        ];

        if (result.signedRuleList.length !== 0) {
          this.ruleForm.signedRuleJson = result.signedRuleList;
          this.ruleForm.signedRuleJson[0].couponsId = 333;
          let couponSendIds = [];
          result.signedRuleList.filter(v => {
            couponSendIds.push(v.couponsId);
          });

          this.$store.dispatch("findCouponSendByEvent", { couponSendIds });

          this.ruleForm.signedRuleJson.forEach(v => {
            if (
              this.findCouponSendByEvent.findIndex(
                o => o.couponSendId === v.couponsId
              ) < 0
            ) {
              v.couponsIds = JSON.parse(JSON.stringify(v.couponsId));
              v.couponsId = v.couponName;
              v.overdue = true;
            }
          });
        }
      }
    });
  },
  methods: {
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    couponsIdChange(i) {
      this.ruleForm.signedRuleJson[i].overdue = false;
    },
    filterGt0OrFixed0(prop, i) {
      this.ruleForm.signedRuleJson[i][prop] = this.ruleForm.signedRuleJson[i][
        prop
      ].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.signedRuleJson[i][prop] = this.ruleForm.signedRuleJson[i][
        prop
      ]
        .replace(".", "")
        .replace("-", "");

      this.ruleForm.signedRuleJson[i][prop] = this.ruleForm.signedRuleJson[i][
        prop
      ].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    prizeTypeChange(i) {
      this.ruleForm.signedRuleJson[i].integralAmount = "";
      this.ruleForm.signedRuleJson[i].couponsId = "";
    },
    detailSignInActivity() {
      const { signedActivityId } = this.$route.query;
      const params = {
        signedActivityId
      };
      return this.$store.dispatch("detailSignInActivity", params);
    },
    addChild() {
      this.ruleForm.signedRuleJson.push({
        integralAmount: "",
        couponsId: "",
        rewardUpperLimit: "",
        addupDay: "",
        continuityDay: ""
      });
    },
    deleteChild(i, index) {
      this.ruleForm.signedRuleJson.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;

          params.signedStartday = this.ruleForm.applyDate[0];
          params.signedEndday = this.ruleForm.applyDate[1];
          params.signedActivityId = this.$route.query.signedActivityId;
          params.signedRuleJson.forEach(v => {
            if (v.overdue) {
              v.couponsId = v.couponsIds;
            }
          });
          this.$store.dispatch("editSignInActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}
.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}

.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
</style>
